export type Listener = () => void;

// oxlint-disable-next-line typescript/no-unnecessary-type-parameters -- TSnapshot constrains the subclass's `snapshot` return type, which the subscribe-and-read pattern depends on
export abstract class ObservableModel<TSnapshot> {
  private readonly listeners: Set<Listener> = new Set();

  readonly subscribe: (listener: Listener) => () => void = (listener) => {
    this.listeners.add(listener);

    return () => {
      this.listeners.delete(listener);
    };
  };

  abstract get snapshot(): TSnapshot;

  protected notify(): void {
    for (const listener of this.listeners) listener();
  }
}
